<script>
    import { url } from "@roxi/routify";

    let { value, rowIndex, rowId, instructKey } = $props();

    let data = $derived(value);
</script>

{#if data}
    {#if Array.isArray(data.location)}
        {#each data.location as loc}
            <div>
                <a
                    href={$url(`/property/${data.target_object_type}/loc`, {
                        value: encodeURIComponent(loc),
                        ...data.filters,
                    })}
                    title="Ver propiedades en esta ubicación">{loc}</a
                >
            </div>
        {/each}
    {:else if !Array.isArray(data.location) && data.location != "General"}
        <a
            href={$url(`/property/${data.target_object_type}/loc`, {
                value: encodeURIComponent(data.location),
                ...data.filters,
            })}
            title="Ver propiedades en esta ubicación">{data.location}</a
        >
    {:else}
        {data.location}
    {/if}
{/if}

<style>
</style>
